import { useMemo, useState } from 'react';
import { convertToKFormat } from 'common/utils/convertToKFormat';
import { useTranslations } from 'hooks/useTranslations';

const useTokenUsage = ({botsUseCaseLabel}) => {
  const [tokenUsage, setTokenUsage] = useState(200000);
  const { t } = useTranslations()
  const handleTokenUsageChange = (
    event,
    newValue
  ) => {
    setTokenUsage(newValue );
  };
  const columns= [
    { title: t('pricing.usage_case'), width: '50%' },
    { title: t('pricing.volume'), width: '50%' },
  ];

  const rows = useMemo(() => {
    if (!botsUseCaseLabel.length) return [];
 
    return botsUseCaseLabel.map((bot) => [
      { value: bot.useCaseLabel },
      {
        value: `${convertToKFormat(
          tokenUsage / (bot.swiftaskTokenCoef)
        )} ${bot.quantityLabel}`,
      },
    ]);
  }, [botsUseCaseLabel, tokenUsage]);
  return { tokenUsage, handleTokenUsageChange, columns, rows };
};
export default useTokenUsage;
